var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('path',{attrs:{"d":"M11 22A11 11 0 1 0 0 11a11 11 0 0 0 11 11zm0-.667A10.333 10.333 0 1 1 21.333 11 10.333 10.333 0 0 1 11 21.333z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M10.5 16v-4h-4v-1h4V7h1v4h4v1h-4v4z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }